import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from '../api/apiClient';

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: (headers) => {
      const storedUser = sessionStorage.getItem('hrms_user');
      if (storedUser) {
        try {
          const user = JSON.parse(storedUser);
          if (user && user.token) {
            headers.set('authorization', `Bearer ${user.token}`);
          }
        } catch (error) {
          console.error('Failed to parse user from session storage', error);
        }
      }
      return headers;
    },
  }),
  tagTypes: [
    'Leave', 'Attendance', 'AttendanceRegularization', 'Employee', 'Payroll', 'Job', 'Candidate',
    'Performance', 'Training', 'Department', 'Task', 'Project', 'Company', 'Role', 'Holiday',
    'CompanyDocument', 'Message', 'Notification', 'Invoice', 'Client', 'LeaveType'
  ],
  endpoints: (builder) => ({}),
});
